import { useState } from "react";

const WidgetFilterDropdown = ({ value, valueChange, dropDownList }) => {
  const [selectOpen, setSelectOpen] = useState(false);

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <select
        value={value}
        onChange={(e) => valueChange(e)}
        onFocus={() => setSelectOpen(true)}
        onBlur={() => setSelectOpen(false)}
        style={{
          minWidth: "60px",
          maxWidth: "120px",
          height: "24px",
          border: "1px solid var(--dropdown-border)",
          borderRadius: "24px",
          padding: "4px 18px 4px 10px",
          fontSize: "12px",
          color: "var(--card-secondary-color)",
          appearance: "none", // removes default arrow
          background: "white",
        }}
      >
        {dropDownList.map((dropDown, index) => (
          <option
            key={index}
            value={dropDown.value}
            style={{ fontSize: "12px", color: "var(--card-secondary-color)" }}
          >
            {dropDown.label}
          </option>
        ))}
      </select>

      {/* Custom Arrow */}
      <span
        style={{
          position: "absolute",
          right: "8px",
          top: "50%",
          transform: selectOpen ? "translateY(-50%) rotate(180deg)" : "translateY(-50%)",
          transition: "transform 200ms cubic-bezier(0.4, 0, 0.2, 1)",
          fontSize: "14px",
          color: "var(--card-secondary-color)",
          pointerEvents: "none", // prevent blocking clicks
        }}
      >
        ▼
      </span>
    </div>
  );
};

export default WidgetFilterDropdown;
